<template>
  <div class="home">
    <div class="loginBox" v-if="status===false">
      <div class="title">请输入密码</div>
      <input v-model="password" type="password" placeholder="请输入密码" @keyup="s"/>
      <van-button block class="button" type="primary" @click="submit">查看文档</van-button>
    </div>
    <doc v-if="status"></doc>
  </div>
</template>

<script>
// import config from "./config";

import Doc from "./views/doc";

export default {
  components: {Doc},
  data() {
    return {
      status: false,
      password: '',
    };
  },
  mounted() {
    this.$store.dispatch('checkPassword', this.password).then(res => {
      this.status = res.status;
    })
  },
  methods: {
    s(e) {
      if (e.key === 'Enter') {
        this.submit();
      }
    },
    submit() {
      if (!this.password) {
        return this.$toast('请输入文档密码！');
      }
      this.$store.state.password = this.password;
      this.$store.dispatch('login', this.password).then(res => {
        this.status = res.status;
        if (this.status) {
          this.$notify({
            type: 'success',
            message: '登录成功！'
          });
        } else {
          this.$notify({
            type: 'danger',
            message: '密码错误，登录失败！'
          });
        }
      })
    }
  }
}
</script>
<style lang="less" scoped>
@import "./assets/common";

.home {
  height: 100vh;
  box-sizing: border-box;
}

.loginBox {
  width: 300px;
  margin: 0 auto;
  padding: 30px;
  border: 1px solid #eee;
  margin-top: 14%;
  border-radius: 5px;
  box-shadow: 6px 6px 6px #eee;

  .title {
    padding-bottom: 20px;
    text-align: center;
    color: #555;
    font-size: 18px;
  }

  input {
    width: 100%;
    line-height: 40px;
    border: 1px solid #eee;
    color: #444;
    box-sizing: border-box;
    padding: 0 20px;
    font-size: 16px;
    border-radius: 5px;
  }

  .button {
    margin-top: 20px;
  }
}

@media screen and (max-width: 500px) {

  .loginBox {
    width: 70%;
    margin: 0 auto;
    padding: 30px;
    margin-top: 25%;
    border: 1px solid #eee;
    border-radius: 3px;
    box-shadow: 5px 5px 5px #eee;

    .title {
      padding-bottom: 20px;
      text-align: center;
      color: #555;
      font-size: 16px;
    }

    input {
      width: 100%;
      line-height: 40px;
      border: 1px solid #eee;
      color: #444;
      box-sizing: border-box;
      padding: 0 15px;
      font-size: 13px;
      border-radius: 3px;
    }
  }
}
</style>
<style>
.show_subscribe .van-dialog__confirm {
  display: none;
}

</style>
